module.exports = __webpack_public_path__ + "static/media/ct-bw.6bde8132.png";